
import React from 'react';

interface LogoProps {
  className?: string;
  variant?: 'default' | 'light';
  onClick?: () => void;
}

const Logo: React.FC<LogoProps> = ({ className = "h-12", variant = 'default', onClick }) => {
  const isLight = variant === 'light';
  
  return (
    <div 
      className={`flex items-center gap-2 sm:gap-3 select-none cursor-pointer group ${className}`} 
      onClick={onClick}
      role="img"
      aria-label="Logo Compre em Guarulhos"
    >
      <div className="h-full aspect-square relative flex items-center justify-center transition-transform duration-500 group-hover:scale-110">
        <svg viewBox="0 0 200 200" className="w-full h-full drop-shadow-sm">
          {/* Lojas de fundo */}
          <path d="M40,90 L80,90 L80,120 L40,120 Z" fill="#0067B1" />
          <path d="M35,90 L85,90 L60,75 Z" fill="#004e8a" />
          <circle cx="60" cy="105" r="8" fill="white" opacity="0.2" />
          
          <path d="M120,90 L160,90 L160,120 L120,120 Z" fill="#F47920" />
          <path d="M115,90 L165,90 L140,75 Z" fill="#d16212" />
          <path d="M135,100 Q140,95 145,100" stroke="white" strokeWidth="2" fill="none" opacity="0.5" />

          {/* Loja Central */}
          <path d="M75,70 L125,70 L125,110 L75,110 Z" fill="#E63946" />
          <path d="M70,70 L130,70 L100,50 Z" fill="#b12a34" />
          <path d="M95,85 L105,85 L105,95 L95,95 Z" fill="white" opacity="0.3" />

          {/* Marcador de Localização Style Chevron/Pin */}
          <path 
            d="M100,160 L50,110 Q100,130 150,110 Z" 
            fill={isLight ? "#FFFFFF" : "#0067B1"} 
          />
          <circle cx="100" cy="115" r="15" fill={isLight ? "#1D264F" : "white"} />
          <circle cx="100" cy="115" r="8" fill="#0067B1" />
          
          {/* Overlay de Brilho */}
          <path d="M100,160 L50,110 L100,120 Z" fill="black" opacity="0.1" />
        </svg>
      </div>

      <div className="flex flex-col leading-none">
        <span className={`font-title font-bold text-[0.75em] sm:text-[0.85em] tracking-tight ${isLight ? 'text-white' : 'text-brand-blue'}`}>
          Compre em
        </span>
        <span className={`font-title font-black text-[1.1em] sm:text-[1.3em] tracking-tighter uppercase italic -mt-1 ${isLight ? 'text-white' : 'text-brand-orange'}`}>
          Guarulhos
        </span>
        <div className={`hidden sm:flex h-[1px] w-full mt-1 items-center gap-1 ${isLight ? 'bg-white/20' : 'bg-gray-200'}`}>
          <div className={`h-full w-4 ${isLight ? 'bg-brand-orange' : 'bg-brand-orange'}`}></div>
          <span className={`text-[0.4em] font-black uppercase tracking-[0.2em] whitespace-nowrap ${isLight ? 'text-white/40' : 'text-gray-400'}`}>
            LISTAR COMÉRCIOS LOCAIS
          </span>
          <div className={`h-full w-4 ${isLight ? 'bg-brand-orange' : 'bg-brand-orange'}`}></div>
        </div>
      </div>
    </div>
  );
};

export default Logo;
